import { ITableChartSettings, ITableWidgetDataRow } from '@/pages/Dashboards/Charts/TableChart/tableChart.types.ts'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import EquipmentMultiSelect from '@/pages/Equipment/components/Common/EquipmentMultiSelect'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { Fragment } from 'react'
import TrashButton from '@/shared/Buttons/TrashButton'
import ParameterDropdown from '@/pages/Parameters/components/ParameterDropdown'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'

interface IProps {
  settings: ITableChartSettings
  onChange: (value: any, key: string) => void
  handleDataRowDelete: (index: number) => void
  handleDataRowUpdate: (index: number, value: any, key: string) => void
  handleDataRowCreate: () => void
}

const TableChartSettingsContent = (props: IProps) => {
  const renderRow = (row: ITableWidgetDataRow, index: number) => {
    return (
      <Fragment key={index}>
        <div className="inline-flex-gap gap16" style={{ alignItems: 'flex-end' }}>
          <FormField label="Заголовок" style={{ width: '100%' }}>
            <TextInput
              value={row.title}
              name="title"
              onChange={(val, name) => props.handleDataRowUpdate(index, val, name)}
              placeHolder="Введите заголовок"
            />
          </FormField>
          <FormField label="Переменная" style={{ width: '100%' }}>
            <ParameterDropdown
              placeholder="Выберите из списка"
              value={row.parameterId}
              name="parameterId"
              onChange={(val, name) => {
                props.handleDataRowUpdate(index, val, name)
              }}
            />
          </FormField>
          <div style={{ flexShrink: 0 }}>
            <TrashButton onClick={() => props.handleDataRowDelete(index)} />
          </div>
        </div>
        <SeparateLine />
      </Fragment>
    )
  }

  return (
    <div className="flex-lines gap16" style={{ paddingRight: '24px' }}>
      <FormField label="Наименование" required={true}>
        <TextInput
          value={props.settings.title}
          name="title"
          onChange={props.onChange}
          placeHolder="Введите наименование"
        />
      </FormField>
      <FormField label="Устройства" required={true}>
        <EquipmentMultiSelect selected={props.settings.equipment} onSelect={props.onChange} name="equipment" />
      </FormField>
      <SeparateLine />
      <h5 className="text-heading-5">Данные таблицы</h5>
      {props.settings.dataRows.map(renderRow)}
      <CreateEntityButton
        onClick={props.handleDataRowCreate}
        text="Добавить параметр"
        type="default"
        fullWidth={true}
      />
    </div>
  )
}

export default TableChartSettingsContent
